export const SET_USER = "SET_USER";
export const SET_UPDATE_CONTACT = "SET_UPDATE_CONTACT";
export const SET_UPDATE_CONTACT_INFO = "SET_UPDATE_CONTACT_INFO";
export const SET_UPDATE_CONTACT_KEY = "SET_UPDATE_CONTACT_KEY";